import {observer} from "mobx-react";
import {ModalDialog, Page, PageContentTitle} from "../../ui";
import {
    DialogStore,
    growlStore,
    slsCreateStore,
    slsCustomerStore,
    slsUserStore,
    validationStore
} from "../../../store";
import {useState} from "react";
import {useNavigate} from "react-router";
import {SlsForm, SlsFormValidation} from "./SlsForm";

const SlsCreatePage = observer(function SlsCreatePage() {
    const [cancelDialog] = useState(new DialogStore())
    const navigate = useNavigate()


    const validation: SlsFormValidation = {
        correlationId: validationStore.getFor('correlationId'),
        customer: validationStore.getFor('customer') || validationStore.getFor('customerId'),
        user: validationStore.getFor('user') || validationStore.getFor('userId')
    }


    const display = 'Neuen Einlagerungsprozess anlegen'

    return <Page
        breadcrumb={[
            {
                link: '/sls',
                label: 'Einlagerung'
            },
            {
                link: '/sls/create',
                label: display
            }
        ]}
    >
        <ModalDialog
            store={cancelDialog}
            actions={[
                {
                    label: "Abbrechen",
                    execute: async function () {
                        cancelDialog.dialogOpen = false
                    },
                    className: 'is-primary is-rounded is-small'
                },
                {
                    label: "Verwerfen",
                    execute: async function () {
                        slsCreateStore.reset()
                        cancelDialog.dialogOpen = false
                        navigate('/sls')
                    },
                    className: 'is-rounded is-small'
                }
            ]}
            title={"Änderungen verwerfen?"}
        >
            Sind Sie sich sicher, dass Sie die Änderungen verwerfen wollen?
        </ModalDialog>
        <PageContentTitle
            actions={[
                {
                    label: 'Speichern',
                    cls: `is-primary ${slsCreateStore.creating ? 'is-loading' : ''}`,
                    disabled: !(slsCreateStore.dirty && slsCreateStore.valid),
                    action: async () => {
                        const id = await slsCreateStore.create()
                        slsCreateStore.reset()
                        growlStore.add({
                            message: 'Der Einlagerungsprozess wurde erfolgreich hinzugefügt',
                            autoclose: true,
                            closable: true
                        })
                        navigate(`/sls/${id}`)
                    }
                },
                {
                    label: 'Verwerfen',
                    cls: 'is-primary is-outlined',
                    disabled: slsCreateStore.creating || !slsCreateStore.dirty,
                    action: async () => {
                        cancelDialog.dialogOpen = true
                    }
                },
            ]}
        >{display}</PageContentTitle>
        <SlsForm
            validation={validation}
            customers={slsCustomerStore.items}
            users={slsUserStore.items}
            data={slsCreateStore.formData}
            onChange={data => slsCreateStore.formData = data}
            onBlur={() => slsCreateStore.validate()}
            mode={'create'}
            onSearchCustomer={async (query) => await slsCustomerStore.search(query)}
            onSearchUser={async (query) => await slsUserStore.search(query)}
            onRemovePlacementProcessDocument={(documentId) => {slsCreateStore.removeDocument(documentId)}}
        />
    </Page>
})

export {
    SlsCreatePage
}
